import Group from 'actions/group';

export default Group.createReducer();
